module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/367.bf20be09.png";